import { ProductAttributesService } from '../../services/productAttributes';

/**
 * Jeep configurator instance of ProductAttributesService.
 *
 * Default product ID is 2644 (Wrangler JL), but initAllProducts()
 * passes explicit IDs via getAttributes(productId) so the default
 * is only used as a fallback.
 */
export const jeepProductService = new ProductAttributesService({
  apiBaseUrl: 'https://renderadmin.vivid3d.tech',
  productId: 2644,
});
